export default {"src":"/_next/static/media/bg.35d304b1.svg","height":378,"width":631,"blurWidth":0,"blurHeight":0};